import PropTypes from 'prop-types'

import { ActivityTypes } from '../../models/activityTypes/activity-types-enum'
import { TripModes } from '../../models/trip/trip-modes-enum'
import { idPropType } from '../common/id-prop-type'
import { iso8601PropType } from '../common/iso-8601-prop-type'

/**
 * @typedef {Object} ObjectActivity
 * @property {string} activityId - The activity id
 * @property {ISO8601} activityType - The activity type
 * @property {ISO8601} lastModified - The last-modified time of the object activity
 * @property {Id} objectId - The ID of the object
 * @property {ISO8601} startTime - The start time of the object activity
 * @property {boolean} suspectedEndless - The suspected endless flag of the object activity
 * @property {string} tripMode - The trip mode of the object activity
 */
const objectActivityPropType = PropTypes.shape({
    activityId: PropTypes.string,
    activityType: PropTypes.oneOf(Object.values(ActivityTypes)),
    endTime: iso8601PropType,
    lastModified: iso8601PropType,
    objectId: idPropType,
    startTime: iso8601PropType,
    suspectedEndless: PropTypes.bool,
    tripMode: PropTypes.oneOf(Object.values(TripModes))
})

export { objectActivityPropType }
